var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/ellipsis"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.8333 10C10.8333 10.4602 10.4602 10.8333 10 10.8333C9.53976 10.8333 9.16667 10.4602 9.16667 10C9.16667 9.53976 9.53976 9.16667 10 9.16667C10.4602 9.16667 10.8333 9.53976 10.8333 10Z",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#87958F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.6667 10C16.6667 10.4602 16.2936 10.8333 15.8333 10.8333C15.3731 10.8333 15 10.4602 15 10C15 9.53976 15.3731 9.16667 15.8333 9.16667C16.2936 9.16667 16.6667 9.53976 16.6667 10Z",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#87958F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5 10C5 10.4602 4.6269 10.8333 4.16667 10.8333C3.70643 10.8333 3.33333 10.4602 3.33333 10C3.33333 9.53976 3.70643 9.16667 4.16667 9.16667C4.6269 9.16667 5 9.53976 5 10Z",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#87958F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.a7b458c160751f5df85ecd143febf206.svg";
export { ForwardRef as ReactComponent };